<template>
  <footer>
    <donation-button />
    <changelog-button />
    <feedback-button />
  </footer>
</template>

<script setup>
import DonationButton from "@/components/donation/DonationButton.vue";
import ChangelogButton from "@/components/changelog/ChangelogButton.vue";
import FeedbackButton from "@/components/feedback/FeedbackButton.vue";
</script>

<style scoped lang="scss">
footer {
  position: fixed;
  bottom: 0;
  right: 0;
  padding: 10px;
  padding-bottom: 0;
  margin-right: 2vw;
  display: flex;
  justify-content: flex-end;
  column-gap: 1.5vw;
  z-index: 2;
}
</style>